import { connect } from 'react-redux';
import { TemplateChannel } from 'entities/campaign/rulesets/channels';
import { Selectors as Templates } from 'sections/assets/state/templates';
import { Selectors as Rulesets } from 'sections/campaigns/state/rulesets';
import { Selectors as RulesetSplitTests } from 'sections/campaigns/state/rulesetSplitTests';
import { State } from 'store';
import { Props, TemplatePercentageSummary } from './templatePercentageSummary';

interface OwnProps {
  rulesetSplitTestId: string;
}

export const mapStateToProps = (state: State, ownProps: OwnProps): Props => {
  const splitTest = RulesetSplitTests.getEntity(state, ownProps.rulesetSplitTestId);
  const ruleset = splitTest && Rulesets.getEntity(state, splitTest.rulesetId);
  const defaultChannel = ruleset && (ruleset.channels[0] as TemplateChannel);

  const defaultTemplate = ruleset && Templates.getEntity(state, defaultChannel.templateId);
  const variantWeight = splitTest && splitTest.variants[0].weight;
  return {
    templatePercentage: defaultTemplate
      ? {
          name: defaultTemplate.name,
          percentage: 100 - variantWeight,
        }
      : null,
  };
};

export default connect(mapStateToProps)(TemplatePercentageSummary);
